import { Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService<T> implements OnDestroy {
  protected value$ = new ReplaySubject<T | undefined>(1);

  private value: T | undefined;
  private subscriptions = new Array<Subscription>();

  constructor() {
    this.refresh();
  }

  ngOnDestroy(): void {
    this.cleanUp();
  }

  public addSubscription(sub: Subscription) {
    this.subscriptions.push(sub);
  }

  public get(): T | undefined {
    return this.value;
  }

  public get$(): Observable<T | undefined> {
    return this.value$.asObservable();
  }

  public async set(val: T | undefined) {
    // skip if the value hasn't changed
    if (val === this.value) {
      return;
    }

    this.value = val;
    this.value$.next(val);
  }

  public async refresh() {
    this.value = await this.get();
    this.value$.next(this.value);
  }

  public reset() {
    this.value = undefined;
    this.value$.next(undefined);
  }

  protected clearSubscriptions() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
    this.subscriptions = [];
  }

  protected cleanUp() {
    this.clearSubscriptions();
  }
}
